/* Home 2609 – Brewery Map
   Brewery polaroids appear next to the yellow dots, 3 or 4 at a time, and change every 4.2 seconds while the map is on screen
   (same timing as the mock). Positions are SVG coordinates (649 × 720) set in the section.
   Reduced motion: the first group is shown and stays; nothing moves or changes. */
(function () {
  var W = 649;
  var H = 720;
  var GROUPS = [[0, 3, 6], [1, 4, 5], [0, 2, 6], [1, 3, 5, 4]];
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.h2609Ready) return;
    root.h2609Ready = true;
    var wrap = root.querySelector('[data-h2609-snaps]');
    if (!wrap) return;
    var snaps;
    try { snaps = JSON.parse(wrap.getAttribute('data-h2609-snaps')); } catch (e) { return; }

    var els = snaps.map(function (sn) {
      var pin = document.createElement('i');
      pin.className = 'h2609-snap-pin';
      pin.style.left = (sn.x / W * 100) + '%';
      pin.style.top = (sn.y / H * 100) + '%';
      var fig = document.createElement('figure');
      fig.className = 'h2609-snap';
      fig.style.setProperty('--r', sn.r + 'deg');
      fig.style.setProperty('--dx', (sn.dx || 0) + 'px');
      fig.style.left = Math.min(86, Math.max(14, sn.x / W * 100)) + '%';
      fig.style.top = (sn.y / H * 100) + '%';
      var img = document.createElement('img');
      img.src = sn.img;
      img.alt = '';
      img.width = 536;
      img.height = 628;
      img.loading = 'lazy';
      img.draggable = false;
      fig.appendChild(img);
      wrap.appendChild(pin);
      wrap.appendChild(fig);
      return { fig: fig, pin: pin };
    });

    var g = 0;
    var timer = null;
    var pending = [];

    function clearPending() {
      pending.forEach(function (t) { clearTimeout(t); });
      pending = [];
    }

    function show(group, animate) {
      clearPending();
      els.forEach(function (e) { e.fig.classList.remove('is-on'); e.pin.classList.remove('is-on'); });
      group.forEach(function (i, k) {
        if (!els[i]) return;
        if (!animate) { els[i].pin.classList.add('is-on'); els[i].fig.classList.add('is-on'); return; }
        pending.push(setTimeout(function () {
          els[i].pin.classList.add('is-on');
          pending.push(setTimeout(function () { els[i].fig.classList.add('is-on'); }, 350));
        }, k * 450));
      });
    }

    function next() { show(GROUPS[g], true); g = (g + 1) % GROUPS.length; }
    function start() { if (timer || REDUCED.matches) return; next(); timer = setInterval(next, 4200); }
    function stop() { clearInterval(timer); timer = null; }

    if (REDUCED.matches) {
      show(GROUPS[0], false);
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.35 });
      io.observe(root.querySelector('.h2609-dotmap') || root);
      root.h2609Stop = function () { stop(); clearPending(); io.disconnect(); };
    } else {
      start();
      root.h2609Stop = function () { stop(); clearPending(); };
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-h2609-map]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor
  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target.querySelectorAll('[data-h2609-map]');
    for (var i = 0; i < roots.length; i++) if (roots[i].h2609Stop) roots[i].h2609Stop();
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
